document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".marquee").forEach(function(e) {
    var a = [{
      transform: "translateX(0)"
    }, {
      transform: "translateX(calc(-100% - 45px))"
    }]
    , t = {
      duration: 2e4 * e.dataset.duration,
      direction: e.dataset.reverse ? "reverse" : "normal",
      iterations: 1 / 0
    }
    , r = [];

    (n = e.querySelector(".marquee-group").cloneNode(!0)).classList.add("clone"),
    e.appendChild(n);
    var n;
    Array.from(e.querySelectorAll(".marquee-group")).forEach(function(e) {
      e = e.animate(a, t);
      r.push(e)
    });
    "true" === e.dataset.slowdown && (e.addEventListener("mouseenter", function() {
      r.forEach(function(e) {
        e.playbackRate = .2
      })
    }),
    e.addEventListener("mouseleave", function() {
      r.forEach(function(e) {
        e.playbackRate = 1
      })
    }))
  })
});